import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useContext, useEffect, useRef } from "react";
import { CRUDContext } from "./CompaniesTable";
import { endpoints } from "../../Utils/UrlEnum";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { postData } from "../../Services/postData";
import { updateData } from "../../Services/updateData";
import { CompanyFormProps } from "../../Utils/Types";
import { FormsIds } from "../../Utils/Constants";
import Config from "../../Utils/Config";
import { CompanyFormValidationSchema } from "../../Utils/Models";
import { onFormError } from "../../Utils/Utils";

export default function CompanyForm(props: CompanyFormProps) {
  const companyContext: any = useContext(
    props.selectedCompany ? props.selectedCompany : CRUDContext
  );
  const ref: any = useRef();
  const firstUpdate = useRef(true);
  const {
    register,
    control,
    handleSubmit,
    watch,
    getValues,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(CompanyFormValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    context: undefined,
    shouldFocusError: true,
    shouldUnregister: false,
    criteriaMode: "firstError",
    defaultValues: {
      visible: true,
    },
  });
  const formData = useWatch({ control: control });

  /**
   *
   */
  useEffect(() => {
    if (formData && !firstUpdate.current) {
      props.setContextValue({
        ...formData,
      });
    }
  }, [formData]);

  /**
   *
   */
  useEffect(() => {
    if (companyContext.name && companyContext.name !== "") reset(companyContext);
  }, []);

  /**
   *
   */
  useEffect(
    () => {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        return;
      }
      if (!firstUpdate.current) ref.current.submit();
    },
    [
      // props.shouldHandleSubmit
    ]
  );

  /**
   *
   * @param id
   */
  const updateElement = async (model: any) => {
    const url = `${endpoints.company.main}/${companyContext?._id}`;
    const res = (await updateData(url, model)) as any;
    if (!res || res?.error) {
      return;
    }
    //   if (props.selectedWorkPoint) {
    //     localStorage.setItem("userName", res?.data?.username);
    //   }
    props.setContextValue([]);
    props.onClose();
  };

  /**
   *
   * @param id
   */
  const createElement = async (model: any) => {
    const url = `${endpoints.company.main}`;
    const res = (await postData(url, model)) as any;
    if (!res || res?.error) {
      return;
    }
    props.onClose();
    props.setContextValue([]);
  };

  /**
   *
   * @param model
   */
  const onSubmit = (model: any) => {
    companyContext._id ? updateElement(model) : createElement(model);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit, onFormError)}
      method="get"
      ref={ref}
      id={FormsIds.companyForm}
    >
      <Grid container spacing={Config.standardGridSpacing}>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("name")}
            id="name"
            name="name"
            label={Vocabulary.name}
            value={getValues("name") || ""}
            fullWidth
            variant="outlined"
            error={typeof formState.errors.name === "object"}
            helperText={formState.errors.name?.message?.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("phoneNumber")}
            value={getValues("phoneNumber") || ""}
            name="phoneNumber"
            id="phoneNumber"
            label={Vocabulary.phoneNumber}
            fullWidth
            variant="outlined"
            error={typeof formState.errors.phoneNumber === "object"}
            helperText={formState.errors.phoneNumber?.message?.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("email")}
            variant="outlined"
            name="email"
            value={getValues("email") || ""}
            id="email"
            label={Vocabulary.email}
            fullWidth
            error={typeof formState.errors.email === "object"}
            helperText={formState.errors.email?.message?.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("CUI")}
            variant="outlined"
            name="CUI"
            value={getValues("CUI") || ""}
            id="CUI"
            label={Vocabulary.CUI}
            fullWidth
            error={typeof formState.errors.CUI === "object"}
            helperText={formState.errors.CUI?.message?.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                {...register("visible")}
                checked={watch(`visible`)}
                // value={getValues("visible") || true}
                name="visible"
                id="visible"
              />
            }
            label={Vocabulary.isActive}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("address.country")}
            value={getValues("address.country") || ""}
            name="address.country"
            id="address.country"
            label={Vocabulary.country}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("address.city")}
            value={getValues("address.city") || ""}
            name="address.city"
            id="address.city"
            label={Vocabulary.city}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("address.county")}
            value={getValues("address.county") || ""}
            name="address.county"
            id="address.county"
            label={Vocabulary.county}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <TextField
            {...register("address.postcode")}
            value={getValues("address.postcode") || ""}
            name="address.postcode"
            id="address.postcode"
            label={Vocabulary.postcode}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>
    </form>
  );
}
